import { type AdData, ConfigName } from '../../types';
import { useAdDataContext } from '../../useAdDataContext';
import { ContentContext } from '../ContentDataProvider';
import type { ContentConfig } from '../types';

export function useContentConfig(): AdData<ContentConfig> {
  return useAdDataContext(ConfigName.CONTENT, ContentContext);
}
